module.exports = require("@material-ui/icons/Equalizer");